import React, {useEffect} from "react";

const Protection = () =>{

    useEffect(()=>{

        //Right-click disable
        const handleContextMenu = (e) => {
            e.preventDefault();
            console.log('Right-click is disabled.');
        };

        //Keyboard shortcuts disable (Ctrl+S, Ctrl+P, Ctrl+C, Ctrl+U, PrintScreen)
        const handleKeyDown = (e) => {
            if ( (e.ctrlKey && ['s', 'p', 'u'].includes(e.key.toLowerCase())) || e.key === 'PrintScreen') 
            {
                e.preventDefault();
                console.log('This action is disabled.');
            }
        };

        //Disable text selection
        const handleSelectStart = (e) => {
            e.preventDefault();
        };

        window.addEventListener('contextmenu', handleContextMenu, true);
        window.addEventListener('keydown', handleKeyDown, true);
        //window.addEventListener('selectstart', handleSelectStart, true);

        return () => {
            window.removeEventListener('contextmenu', handleContextMenu, true);
            window.removeEventListener('keydown', handleKeyDown, true);
            //window.removeEventListener('selectstart', handleSelectStart, true);
        };

    }, []);

    return null;
}

export default Protection;
